import { chains, type Address } from ".";
import type { Abi, ChainedContract, } from "./types";

export const lookupContractWithABI = <C extends keyof typeof chains = 1>(
	chain: C,
	contract: ChainedContract,
): [Address, Abi["abi"]] => {
	try {
		if (chain in chains) {
			const { interfaces, contracts } = chains[chain];
			if(contract === "ERC20") {
				return [null, interfaces[contract]]
			}
			if (contract in contracts) {
				if (interfaces[contract]) {
					return [contracts[contract], interfaces[contract]];
				}
				throw new Error(
					`no ABI available on chain ${chain} for contract "${contract}"`,
				);
			}
			throw new Error(
				`no contract address available on chain ${chain} for contract "${contract}"`,
			);
		}
		throw new Error(`invalid or unsupported chain ${chain}`);
	} catch (err) {
		throw new Error(
			`@bracket/addressbook::lookupContract failed ${err.message}`,
		);
	}
};
